import { Button, Box, Paper, Chip } from "@mui/material";
import { styled } from "@mui/material/styles";
import { GRADIENTS, STATUS_COLORS } from './campaignconstants';

export const GradientButton = styled(Button)(({ theme, variant }) => {
  return {
    background: GRADIENTS[variant] || GRADIENTS.primary,
    borderRadius: '12px',
    padding: '12px 24px',
    color: '#fff',
    fontWeight: 600,
    textTransform: 'none',
    boxShadow: '0 8px 32px rgba(220, 38, 57, 0.3)',
    transition: 'all 0.3s ease',
    border: 'none',
    [theme.breakpoints.down('sm')]: {
      padding: '10px 20px',
      fontSize: '0.875rem',
      boxShadow: '0 4px 16px rgba(220, 38, 57, 0.3)',
    },
    '&:hover': {
      background: GRADIENTS[variant] || GRADIENTS.primary,
      transform: 'translateY(-2px)',
      boxShadow: '0 12px 40px rgba(220, 38, 57, 0.4)',
    },
    '&:active': {
      transform: 'translateY(0)',
    },
    '&:disabled': {
      background: '#ccc',
      color: '#666',
    }
  };
});

export const CarouselContainer = styled(Box)(({ theme }) => ({
  background: 'linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%)',
  borderRadius: '20px',
  padding: theme.spacing(3),
  margin: theme.spacing(2, 0),
  position: 'relative',
  overflow: 'hidden',
  height: '400px',
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.down('md')]: {
    height: '450px',
    padding: theme.spacing(2),
    borderRadius: '16px',
  },
  [theme.breakpoints.down('sm')]: {
    height: 'auto',
    minHeight: '320px',
    padding: theme.spacing(2),
    margin: theme.spacing(1, 0),
    borderRadius: '12px',
  },
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'linear-gradient(135deg, rgba(220, 38, 57, 0.1), rgba(153, 27, 27, 0.1))',
    zIndex: 0,
  }
}));

export const MetricCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  borderRadius: '16px',
  background: 'rgba(255, 255, 255, 0.9)',
  backdropFilter: 'blur(10px)',
  border: '1px solid rgba(220, 38, 57, 0.3)',
  textAlign: 'center',
  transition: 'all 0.3s ease',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1.5),
    borderRadius: '12px',
  },
  '&:hover': {
    transform: 'scale(1.05)',
    boxShadow: '0 8px 24px rgba(220, 38, 57, 0.12)',
  }
}));

export const StatusChip = styled(Chip)(({ status, theme }) => {
  const colors = STATUS_COLORS[status] || STATUS_COLORS.Draft;
  return {
    backgroundColor: colors.bg,
    color: colors.color,
    fontWeight: 600,
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.75rem',
      height: '24px',
    },
    '& .MuiChip-icon': {
      color: colors.color,
    }
  };
});

export const MobileActionButton = styled(Button)(({ theme }) => ({
  borderRadius: '12px',
  padding: '10px 16px',
  fontSize: '0.875rem',
  fontWeight: 600,
  textTransform: 'none',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    width: 'auto',
  }
}));

export const CompactCard = styled(Paper)(({ theme }) => ({
  borderRadius: '16px',
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    borderRadius: '12px',
    marginBottom: theme.spacing(2),
  }
}));